import { connect } from 'react-redux';
import { ROUTE_FAN_FEED_POSTS_EDIT }from '../constants';
import actions from '../../../actions/fan_feed/fan_feed_posts';
import {getCurrentClubId} from '../../../selectors/club-settings';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../selectors/crud';
import { push } from 'react-router-redux/lib/actions';
import { setHeaderTitle } from '../../../actions/layout';
import FanFeedPostList from './FanFeedPostList';

export default connect(
  (state) => ({
    headerTitle: 'FanFeed Posts',
    ...listStateFromCRUD(state.fan_feed_posts),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => {
    return {
      updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
      ...listDispatchFromCrud(dispatch, actions),
      edit: (id) => dispatch(push(ROUTE_FAN_FEED_POSTS_EDIT.replace(':id', id || ""))),
      delete: (model) => dispatch(actions.remove(model)),
    };
  }
)(FanFeedPostList);



// WEBPACK FOOTER //
// ./src/components/FanFeed/FanFeedPostList/index.ts